
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 9.8h1.95V4.6H0V2.911A6.128 6.128 0 002.278 2H3.9v7.8h1.95v1.95H0V9.8zM6.155 3.088A2.899 2.899 0 018.861.006a3.105 3.105 0 012.232.763l-.769.9a1.606 1.606 0 00-1.128-.46c-.9 0-1.545.682-1.545 1.829 0 1.172.54 1.85 1.676 1.85.201.006.4-.046.572-.15v-.8h-.65v-1.3h1.95v2.754a3.062 3.062 0 01-2.027.72 2.823 2.823 0 01-3.017-3.024z"}})])
          )
        }
      }
    